import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Analytics from '@wetransfer/transfer/modules/analytics';
import Hooks from '@wetransfer/transfer/modules/analytics/hooks';

const Button = ({
  active,
  align,
  ariaLabel,
  className,
  icon,
  id,
  onClick,
  submit,
  tabIndex,
  text,
  type,
  dataTestId,
}) => {
  const accountType = Hooks.useAccountType();

  const buttonClassName = classNames('button', className, {
    [`button--${type}`]: type,
    [`button--${align}`]: align,
    'button--enabled': active,
    'button--disabled': !active,
  });

  const handleClick = (event) => {
    if (id) {
      Analytics.trackSnowplowEvent({
        category: 'automated_tracking',
        action: id,
        property: accountType,
      });
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      id={id}
      disabled={!active}
      type={submit ? 'submit' : 'button'}
      className={buttonClassName}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      {icon}
      {text}
    </button>
  );
};

Button.propTypes = {
  active: PropTypes.bool,
  align: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.element,
  id: PropTypes.string, // Should be in this format: `${page_name}_page_${button_label}`
  onClick: PropTypes.func,
  submit: PropTypes.bool,
  tabIndex: PropTypes.number,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  dataTestId: PropTypes.string,
};

Button.defaultProps = {
  active: true,
  align: '',
  className: '',
  submit: false,
  tabIndex: 0,
  text: '',
  type: '',
};

export default Button;
